import { Controller } from "@hotwired/stimulus"

// Polls Projects::InstallationChecksController#show until the test event a language quickstart
// page just told a visitor to trigger actually arrives, then flips from "waiting" to "received"
// and stops polling entirely. A much shorter interval than live_list_controller.js's own 10s
// poll: this only ever runs for a few seconds around someone actively testing their setup, not
// indefinitely in the background, so the usual "don't hammer the server with a fast poll" concern
// doesn't apply here the same way.
const POLL_INTERVAL_MS = 2000

export default class extends Controller {
  static values = { url: String, since: String }
  static targets = ["waiting", "received"]

  connect() {
    this.timer = setInterval(() => this.check(), POLL_INTERVAL_MS)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  // Same "skip a poll the tab can't see" reasoning as live_list_controller.js's own refresh; a
  // dropped or failed check just retries on the next tick, nothing to surface for one bad poll.
  async check() {
    if (document.hidden) return

    try {
      const response = await fetch(`${this.urlValue}?since=${encodeURIComponent(this.sinceValue)}`, { headers: { Accept: "application/json" } })
      if (!response.ok) return

      const { received } = await response.json()
      if (received) this.markReceived()
    } catch {
      // See comment above: a dropped poll isn't worth doing anything about.
    }
  }

  markReceived() {
    clearInterval(this.timer)
    this.waitingTarget.hidden = true
    this.receivedTarget.hidden = false
  }
}
